<script setup lang="ts">
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'
import ElementalsAccordionList from '@/components/DrawerSidebarRight/components/ElementalsAccordionList/index.vue'
import type { AccordeonEmits } from '@/components/Accordion/index.vue'

const emits = defineEmits<AccordeonEmits>()
const { kmsElementals, isLoading: isLoadingKMS, refetchKMS } = useGetOnlyKMSElementals()
const user = useUser()
const { state, toggleFavoriteAccordion } = useElementalListsStore()

const handleClose = () => {
  toggleFavoriteAccordion(false)
}

const handlerOpen = () => {
  toggleFavoriteAccordion(true)
}

const handleToggle = (isOpen?: boolean) => {
  emits('onToggle', isOpen)
}

onMounted(() => {
  refetchKMS()
})
</script>

<template>
  <div v-if="user">
    <ElementalsAccordionList
      title="Knowledge Base"
      icon-class="bg-gray-300 h-7 w-7"
      icon-name="i-mdi:book-open-outline text-dark-gray"
      :elementals="kmsElementals || []"
      :is-open="state.knowledgeBaseAccordionOpen"
      :is-loading="isLoadingKMS"
      :columns="['title', 'description', 'actions']"
      :folder-level="2"
      row-class="border-b border-grayLighter"
      @on-close="handleClose"
      @on-open="handlerOpen"
      @on-toggle="handleToggle"
    />
  </div>
</template>
